export * from './exam.service';
